import React from "react";

import "./css/ProjectsPage.css";

function TechList({ items }) {
  return (
    <div className="tech-list">
      {items.map((item) => (
        <span key={item} className="chip">
          {item}
        </span>
      ))}
    </div>
  );
}

const projects = [
  {
    name: "MCP Tool Servers & Agent-Solvable Engineering Work",
    company: "TEKsystems / Symbotic",
    role: "Senior Software Engineer",
    points: [
      "Built MCP servers/tools and Python/TypeScript services so AI agents discover and invoke real APIs under structured contracts (auth, retries, error handling).",
      "Debugged complex agent/runtime failures: bad tool arguments, context loss, authorization, and integration defects; converted them into durable code and contract fixes.",
      "Implemented features and refactored prototypes into reviewed, documented, testable services suitable as reference implementations.",
      "Containerized and shipped on GKE / Cloud Run; investigated performance and reliability issues in distributed, remote delivery.",
    ],
    tech: [
      "Python",
      "TypeScript",
      "JavaScript",
      "MCP",
      "REST APIs",
      "Docker",
      "Kubernetes",
      "GKE",
      "GCP",
    ],
  },
  {
    name: "Agent Workflows, Tests & Human-Verified Solutions",
    company: "US Tech Solutions",
    role: "Software Engineer",
    points: [
      "Built LangChain / LangGraph / MCP workflows where agents call external systems; added logging, tests, security controls, and human-approval gates so outcomes are checkable.",
      "Used AI coding agents for implementation and debugging, then validated generated changes with tests and technical review.",
      "Investigated defects, implemented corrective changes, and promoted only patterns that survived evaluation into reusable production components.",
    ],
    tech: [
      "Python",
      "TypeScript",
      "LangChain",
      "LangGraph",
      "MCP",
      "LLMs",
      "AWS",
      "REST APIs",
      "Docker",
      "Kubernetes",
    ],
  },
  {
    name: "AI Coding Evaluation: Correctness, Maintainability, Performance",
    company: "DataAnnotation.tech",
    role: "Software Engineer",
    points: [
      "Wrote and reviewed programming solutions for an AI-powered coding platform; judged code on correctness, quality, maintainability, and performance.",
      "Worked across Python, JavaScript, HTML, C++, C#, and SQL—identifying bugs, weak abstractions, and faster alternatives.",
      "Applied software engineering principles to validate implementations against expected behavior.",
    ],
    tech: [
      "Python",
      "JavaScript",
      "C++",
      "C#",
      "SQL",
      "Code Review",
      "Performance Evaluation",
    ],
  },
  {
    name: "Rust CSV Data Processing",
    company: "PacteraEdge — UPS / Markaaz",
    role: "Full-Stack Developer",
    points: [
      "Implemented a Rust program to process CSV data files for operational data workflows—parsing records, transforming fields, and producing deterministic outputs for downstream pipelines.",
      "Used Rust for performance-minded file processing alongside Python/Spark pipelines and Java/Python automation on the same project.",
      "Debugged malformed input, encoding, and edge-case rows; kept the tool maintainable and suitable as a reference implementation for batch CSV handling.",
    ],
    tech: ["Rust", "CSV", "Python", "Java", "Spark / PySpark", "Data Processing"],
  },
];

const links = [
  {
    name: "GitHub Repositories",
    href: "https://github.com/ovimura?tab=repositories",
  },
  {
    name: "GitLab Repositories",
    href: "https://gitlab.com/ovidiu-mura",
  },
  {
    name: "Market Updates",
    href: "https://marketupdates.web.app",
  },
];

export default function ProjectsPage() {
  return (
    <div className="wrapper-projects">
      <h1 className="title">Projects</h1>
      <div className="content">
        {projects.map((project) => (
          <article key={project.name} className="project-card">
            <h2 className="project-name">{project.name}</h2>
            <p className="project-meta">
              {project.company}
              <span className="meta-dot">·</span>
              {project.role}
            </p>
            <ul className="project-points">
              {project.points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
            <TechList items={project.tech} />
          </article>
        ))}

        <section className="project-card links-card">
          <h2 className="project-name">Links</h2>
          <ul className="link-list">
            {links.map((link) => (
              <li key={link.href}>
                <span className="link-label">{link.name}</span>
                <a href={link.href} target="_blank" rel="noreferrer">
                  {link.href.replace(/^https:\/\//, "")}
                </a>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
